/* VORELL Back-in-Stock — tükenen ürün varyantında "Stok gelince haber ver".
   Klaviyo client back-in-stock endpoint'ine abone eder (public key). */
(function () {
  if (!/^\/products\//.test(location.pathname)) return;
  var PUBLIC_KEY = 'XQtSp4';
  var handle = location.pathname.split('/products/')[1];
  handle = handle && handle.split('/')[0].split('?')[0];
  if (!handle) return;
  var product = null, wrap = null;

  var css = ''
    + '.vorell-bis{margin-top:16px;font-family:Arial,Helvetica,sans-serif}'
    + '.vorell-bis__btn{display:inline-flex;align-items:center;gap:8px;padding:13px 24px;border-radius:999px;background:#141311;color:#fff;border:0;font-size:13px;font-weight:600;cursor:pointer}'
    + '.vorell-bis__btn:hover{background:#2a2825}'
    + '.vorell-bis__form{display:none;margin-top:12px;gap:8px;max-width:380px}'
    + '.vorell-bis__form.is-open{display:flex}'
    + '.vorell-bis__form input{flex:1;padding:12px 14px;border:1px solid #d8d3ca;border-radius:9px;font-size:13px;font-family:inherit}'
    + '.vorell-bis__form button{padding:12px 18px;border:0;border-radius:9px;background:#FF5A3C;color:#fff;font-weight:600;font-size:13px;cursor:pointer}'
    + '.vorell-bis__note{margin-top:7px;font-size:12px;color:#6E6A64}'
    + '.vorell-bis__msg{margin-top:9px;font-size:13px;font-weight:600;display:none}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function currentVariantId() {
    var f = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (f) { var i = f.querySelector('[name="id"]'); if (i && i.value) return i.value; }
    var m = location.search.match(/[?&]variant=(\d+)/); return m ? m[1] : (product && product.variants && product.variants[0] ? product.variants[0].id : null);
  }
  function variantById(id) { if (!product) return null; var a = product.variants || []; for (var i = 0; i < a.length; i++) if (String(a[i].id) === String(id)) return a[i]; return null; }

  function ensureUI() {
    if (wrap) return;
    var anchor = document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    if (!anchor || !anchor.parentNode) return;
    wrap = document.createElement('div'); wrap.className = 'vorell-bis'; wrap.style.display = 'none';
    wrap.innerHTML = '<button type="button" class="vorell-bis__btn">🔔 Stok gelince haber ver</button>'
      + '<form class="vorell-bis__form" novalidate><input type="email" required placeholder="E-posta adresin" aria-label="E-posta"><button type="submit">Haber Ver</button></form>'
      + '<div class="vorell-bis__note">Tekrar stokta olduğunda ilk sen haberdar ol.</div>'
      + '<div class="vorell-bis__msg"></div>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    wrap.querySelector('.vorell-bis__btn').addEventListener('click', function () { wrap.querySelector('.vorell-bis__form').classList.toggle('is-open'); });
    wrap.querySelector('.vorell-bis__form').addEventListener('submit', function (e) { e.preventDefault(); subscribe(this.querySelector('input').value.trim()); });
  }

  function subscribe(email) {
    var vid = currentVariantId();
    var msg = wrap.querySelector('.vorell-bis__msg'); msg.style.display = 'block';
    if (!email || email.indexOf('@') < 1) { msg.style.color = '#c0392b'; msg.textContent = 'Geçerli bir e-posta gir.'; return; }
    if (!vid) { msg.style.color = '#c0392b'; msg.textContent = 'Varyant bulunamadı.'; return; }
    msg.style.color = '#6E6A64'; msg.textContent = 'Kaydediliyor…';
    var body = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + PUBLIC_KEY, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) { msg.style.color = '#1FB0A8'; msg.textContent = '✓ Tamam! Stok gelince e-posta göndereceğiz.'; wrap.querySelector('.vorell-bis__form').classList.remove('is-open'); }
      else { msg.style.color = '#c0392b'; msg.textContent = 'Bir hata oldu, tekrar dener misin?'; }
    }).catch(function () { msg.style.color = '#c0392b'; msg.textContent = 'Bağlantı hatası, tekrar dener misin?'; });
  }

  function refresh() {
    if (!product) return;
    var v = variantById(currentVariantId());
    var soldOut = v ? !v.available : false;
    ensureUI();
    if (wrap) wrap.style.display = soldOut ? 'block' : 'none';
  }

  fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
    if (!p) return; product = p; refresh();
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('product-form, form[action*="/cart/add"]')) setTimeout(refresh, 60); });
    document.addEventListener('shopify:section:load', refresh);
  }).catch(function () {});
})();
